module.exports = {
    host: "https://bkbaza.vastok.uz",
    // host: "http://localhost:8000",
    // host: "https://backend.gold-uz.uz",
};
